// LoyaltyLion Learn More Make Purchase
function handleDomUpdateRewards(parentEl) {
  const lionElement = parentEl.querySelector('.lion-rule-item--purchase');
  const latteFaqs = document.querySelector('.faq-tabs');
  const newLionElement = lionElement.cloneNode(true);
  lionElement.replaceWith(newLionElement);
  newLionElement.addEventListener('click', () => latteFaqs.scrollIntoView({ behavior: 'smooth', block: 'start' }));
}

const latteRewardList = document.querySelector('.loyalty__earn');
const config = { attributes: true, childList: true, subtree: true };

const callbackLatteRewards = (mutationsList, observer) => {
  for (const mutation of mutationsList) {
    if (mutation.type === 'childList') {
      handleDomUpdateRewards(mutation.target);
      observer.disconnect();
    }
  }
};

const observerLatteRewards = new MutationObserver(callbackLatteRewards);
observerLatteRewards.observe(latteRewardList, config);

// LoyaltyLion Start Earning
function handleDomUpdateSpend(parentEl) {
  const lionElements = parentEl.querySelectorAll('.lion-reward-item__content');
  lionElements.forEach((element) => {
    const signupLink = document.createElement('a');
    signupLink.classList.add('signup-link');
    signupLink.href = '/account/register';
    signupLink.text = 'Start Earning';
    element.append(signupLink);
  });
}

const latteSpendList = document.querySelector('.loyalty__spend');

const callbackLatteSpend = (mutationsList, observer) => {
  for (const mutation of mutationsList) {
    if (mutation.type === 'childList') {
      handleDomUpdateSpend(mutation.target);
      observer.disconnect();
    }
  }
};

const observerLatteSpend = new MutationObserver(callbackLatteSpend);
observerLatteSpend.observe(latteSpendList, config);
